(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-catalog]:not([data-ready])').forEach(catalog => {
      catalog.dataset.ready = 'true';
      const filter = key => {
        let count = 0;
        catalog.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === key)));
        catalog.querySelectorAll('.wl-card').forEach(card => {
          card.hidden = key !== 'all' && card.dataset.category !== key;
          if (!card.hidden) count++;
        });
        const empty = catalog.querySelector('.wl-catalog-empty');
        if (empty) empty.hidden = count > 0;
      };
      catalog.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
      const key = new URLSearchParams(location.search).get('category');
      if (key && [...catalog.querySelectorAll('[data-filter]')].some(b => b.dataset.filter === key)) filter(key);
    });
    scope.querySelectorAll('[data-product]:not([data-ready])').forEach(root => {
      root.dataset.ready = 'true';
      const data = JSON.parse(root.querySelector('[data-variants]').textContent);
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD'}).format(value / 100);
      const form = root.querySelector('.wl-product-form');
      const select = form.querySelector('[data-variant-select]');
      const add = form.querySelector('[data-product-add]');
      const controls = form.querySelector('[data-option-controls]');
      const image = root.querySelector('.wl-gallery-main > img');
      const lightbox = root.querySelector('.wl-lightbox');
      const setImage = (src, alt) => {
        if (!src) return;
        image.removeAttribute('srcset'); image.src = src;
        lightbox.querySelector('img').src = src;
        if (alt) { image.alt = alt; lightbox.querySelector('img').alt = alt; }
        root.querySelectorAll('.wl-thumb').forEach(button => button.setAttribute('aria-current', String(button.dataset.image === src)));
      };
      root.querySelectorAll('.wl-thumb').forEach(button => button.addEventListener('click', () => setImage(button.dataset.image,button.dataset.imageAlt)));
      root.querySelector('[data-open-image]').addEventListener('click', () => {lightbox.showModal(); lightbox.querySelector('button').focus();});
      lightbox.querySelector('button').addEventListener('click', () => lightbox.close());
      lightbox.addEventListener('click', event => {if (event.target === lightbox) lightbox.close();});
      controls.hidden = false; form.classList.add('is-ready');
      if (root.dataset.needsSize === 'true') {select.value = ''; add.disabled = true; add.firstChild.textContent = 'Choose your size ';}
      const qtyInput = form.querySelector('input[name="quantity"]');
      const currentVariant = () => data.find(v => String(v.id) === select.value) || null;
      const basePrice = () => (currentVariant() || data.find(v => v.available) || data[0]).price;
      /* Multi-buy cards: tap sets the quantity; prices follow the selected variant.
         Rounding mirrors the cart (checked in cart.js): each = price - floor(price*pct/100). */
      const multibuy = root.querySelector('[data-multibuy]');
      const renderMultibuy = () => {
        if (!multibuy) return;
        const price = basePrice();
        multibuy.querySelectorAll('[data-mb-qty]').forEach(input => {
          const n = Number(input.dataset.mbQty), pct = Number(input.dataset.mbPct);
          const each = price - Math.floor(price * pct / 100), total = each * n, was = price * n;
          const card = input.closest('.wl-mb');
          const set = (sel, v) => { const el = card.querySelector(sel); if (el) el.textContent = money(v); };
          set('[data-mb-total]', total); set('[data-mb-was]', was); set('[data-mb-each]', each); set('[data-mb-saving]', was - total);
        });
      };
      const syncCards = () => {
        if (!multibuy) return;
        const q = Number(qtyInput?.value) || 1;
        multibuy.querySelectorAll('[data-mb-qty]').forEach(input => { input.checked = Number(input.dataset.mbQty) === q; });
      };
      if (multibuy && qtyInput) {
        multibuy.addEventListener('change', event => {
          const input = event.target.closest('[data-mb-qty]');
          if (!input) return;
          qtyInput.value = input.dataset.mbQty;
          updateSticky();
        });
        qtyInput.addEventListener('input', () => { syncCards(); updateSticky(); });
        select.addEventListener('change', renderMultibuy);
        syncCards();
      }
      /* Sticky add-to-bag bar: shown only once the main buttons have scrolled above the
         viewport. Submits the same product form (same variant + quantity). Kept hidden
         while Shopify's cookie banner is on screen, and while the image lightbox is open. */
      const mobileBuy = root.querySelector('[data-mobile-buy]');
      const stickyAdd = mobileBuy?.querySelector('[data-sticky-add]');
      let pastButtons = false;
      const bannerOpen = () => {
        const b = document.getElementById('shopify-pc__banner');
        if (!b) return false;
        const cs = getComputedStyle(b);
        return b.getClientRects().length > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && Number(cs.opacity) > 0;
      };
      function updateSticky() {
        if (!mobileBuy) return;
        const show = pastButtons && !bannerOpen() && !lightbox.open;
        if (mobileBuy.hidden === show) mobileBuy.hidden = !show;
        if (!stickyAdd) return;
        const variant = currentVariant();
        const needsChoice = !variant;
        stickyAdd.disabled = !!variant && !variant.available;
        stickyAdd.textContent = needsChoice ? 'Choose size' : (variant.available ? 'Add to bag' : 'Sold out');
        const label = mobileBuy.querySelector('[data-sticky-variant]');
        if (label) {
          const picked = [...controls.querySelectorAll('fieldset:not([hidden])')].map(f => f.querySelector('input:checked')?.value).filter(Boolean);
          label.textContent = needsChoice ? 'Choose a size' : (picked.length ? (picked.length === 1 && controls.querySelector('fieldset:not([hidden]) legend')?.textContent.trim().toLowerCase().startsWith('size') ? 'Size ' + picked[0] : picked.join(' / ')) : '');
        }
        const price = mobileBuy.querySelector('[data-mobile-price]');
        if (price) price.textContent = money(basePrice());
        const q = Number(qtyInput?.value) || 1, qty = mobileBuy.querySelector('[data-sticky-qty]');
        if (qty) { qty.hidden = q < 2; qty.textContent = '× ' + q; }
      }
      if (mobileBuy && 'IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          const e = entries[0];
          pastButtons = !e.isIntersecting && e.boundingClientRect.top < 0;
          updateSticky();
        }, {threshold: 0}).observe(form.querySelector('.wl-product-buttons'));
        let raf = 0;
        /* capture: the desktop layout scrolls inside .page-wrapper, whose scroll events do not reach window */
        document.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; updateSticky(); }); }, {passive: true, capture: true});
        lightbox.addEventListener('close', updateSticky);
        stickyAdd?.addEventListener('click', event => {
          if (currentVariant()) return;
          event.preventDefault();
          form.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
          controls.querySelector('fieldset:not([hidden]) input')?.focus({preventScroll: true});
        });
      }
      /* Colour pick -> gallery jumps to that colour's photo (Oct 31 2026). Works before a size is chosen;
         prefers the matching gallery thumbnail so the thumb highlight and image size stay consistent. */
      const colourIdx = [...controls.querySelectorAll('fieldset')].findIndex(f => /^\s*colou?r\b/i.test(f.querySelector('legend')?.textContent || ''));
      const fileStem = u => { try { return new URL(u, location.href).pathname.split('/').pop().replace(/_(\d+x\d*|x\d+)(?=\.[a-z]+$)/i, ''); } catch (e) { return ''; } };
      if (colourIdx > -1) controls.addEventListener('change', event => {
        const input = event.target.closest('input[data-option-index]');
        if (!input || Number(input.dataset.optionIndex) !== colourIdx) return;
        const options = [...controls.querySelectorAll('fieldset')].map(field => field.querySelector('input:checked')?.value);
        const match = data.find(v => v.featured_image && v.options.every((o, i) => o === options[i])) || data.find(v => v.featured_image && v.options[colourIdx] === input.value);
        const fi = match?.featured_image;
        if (!fi?.src) return;
        const thumb = [...root.querySelectorAll('.wl-thumb')].find(b => fileStem(b.dataset.image) === fileStem(fi.src));
        if (thumb) {
          setImage(thumb.dataset.image, thumb.dataset.imageAlt);
          const strip = thumb.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) strip.scrollTo({left: Math.max(0, thumb.offsetLeft - 8), behavior: 'auto'});
        } else if (!('mediaLocked' in root.dataset)) {
          const u = new URL(fi.src, location.href); u.searchParams.set('width', '1200');
          setImage(u.href, fi.alt || input.value);
        }
      });
      controls.addEventListener('change', () => {
        const options = [...controls.querySelectorAll('fieldset')].map(field => field.querySelector('input:checked')?.value);
        const variant = data.find(v => v.options.every((v, index) => v === options[index]));
        controls.querySelectorAll('[data-option-value]').forEach(label => label.textContent = options[Number(label.dataset.optionValue)] || '');
        add.disabled = !variant?.available;
        add.firstChild.textContent = variant ? (variant.available ? 'Add to bag ' : 'Sold out ') : (options.some(v => !v) ? 'Choose your size ' : 'Unavailable ');
        if (!variant) { select.value = ''; updateSticky(); return; }
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', {bubbles:true}));
        root.querySelector('[data-product-price]').textContent = money(variant.price) + ' ' + (root.dataset.currency || 'USD');
        const mobilePrice = root.querySelector('[data-mobile-price]');
        if (mobilePrice) mobilePrice.textContent = money(variant.price);
        if (colourIdx < 0 && variant.featured_image?.src && !('mediaLocked' in root.dataset)) setImage(variant.featured_image.src);
        updateSticky();
        const url = new URL(location.href); url.searchParams.set('variant',variant.id); history.replaceState({},'',url);
      });
      form.addEventListener('submit', async event => {
        if (event.submitter?.name !== 'add') return;
        event.preventDefault();
        if (!currentVariant()) return;
        const error = form.querySelector('[data-product-error]'); error.hidden = true;
        add.disabled = true; add.firstChild.textContent = 'Adding… '; if (stickyAdd) { stickyAdd.disabled = true; stickyAdd.textContent = 'Adding…'; }
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{Accept:'application/json'},body:(() => { const body = new FormData(form); body.delete('wl_multibuy'); return body; })()});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'This option could not be added. Please choose another.');
          location.assign((window.Shopify?.routes?.root || '/') + 'cart');
        } catch (failure) {
          error.textContent = failure.message || 'Please check your bag before trying again.'; error.hidden = false;
          add.disabled = false; add.firstChild.textContent = 'Add to bag ';
          updateSticky();
          if (event.submitter === stickyAdd) form.scrollIntoView({block: 'start'});
        }
      });
    });
    scope.querySelectorAll('[data-kit]:not([data-ready])').forEach(kit => {
      kit.dataset.ready = 'true';
      const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:kit.dataset.currency || 'USD'}).format(value / 100);
      const contents = {duo:['gloves','socks'],core:['vest','gloves'],full:['vest','gloves','socks']};
      const getItems = pack => contents[pack].map(key => {
        const select = kit.querySelector(`[data-kit-select="${key}"]`);
        const option = select.selectedOptions[0];
        return {id:Number(option?.value),quantity:1,price:Number(option?.dataset.price),available:!!option && !option.disabled};
      });
      const refresh = () => {
        const pack = kit.querySelector('input[name="winter-pack"]:checked').value;
        kit.querySelectorAll('[data-kit-item]').forEach(item => item.hidden = !contents[pack].includes(item.dataset.kitItem));
        Object.keys(contents).forEach(key => kit.querySelector(`[data-pack-price="${key}"]`).textContent = money(getItems(key).reduce((sum,item) => sum + item.price,0)));
        const items = getItems(pack);
        kit.querySelector('[data-kit-total]').textContent = money(items.reduce((sum,item) => sum + item.price,0));
        const incomplete = items.some(item => !item.available);
        kit.querySelector('[data-kit-add]').disabled = incomplete;
        kit.querySelector('[data-kit-add]').firstChild.textContent = incomplete ? 'Choose your sizes ' : 'Add kit to bag ';
        const totalLabel = kit.querySelector('[data-kit-total-label]');
        if (totalLabel) totalLabel.textContent = incomplete ? 'Estimated total · choose options' : 'Your kit total';
      };
      kit.addEventListener('change',refresh); refresh();
      kit.querySelector('[data-kit-add]').addEventListener('click',async () => {
        const button = kit.querySelector('[data-kit-add]'); const error = kit.querySelector('[data-kit-error]');
        const pack = kit.querySelector('input[name="winter-pack"]:checked').value;
        const items = getItems(pack);
        if (items.some(item => !item.available)) return;
        button.disabled = true; button.firstChild.textContent = 'Adding your kit… '; error.hidden = true;
        try {
          const response = await fetch((kit.dataset.root || '/') + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items.map(({id,quantity})=>({id,quantity}))})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Your kit could not be added. Check the selected options.');
          location.assign((kit.dataset.root || '/') + 'cart');
        } catch (failure) {error.textContent = failure.message || 'Please check your bag before trying again.';error.hidden = false;button.disabled=false;button.firstChild.textContent='Add kit to bag ';}
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('click',event=>{const link=event.target.closest('.wl-mobile-nav a');if(link)link.closest('details').open=false;});
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();


/* Keep utm_* through to checkout: copy them onto the cart as attributes (they become order attributes). Nothing in the theme strips query params. */
(function(){try{var q=new URLSearchParams(location.search),a={},n=0;q.forEach(function(v,k){if(/^utm_[a-z_]+$/.test(k)&&v){a[k]=v.slice(0,100);n++;}});if(!n)return;var sig=JSON.stringify(a);if(sessionStorage.getItem('wl-utm')===sig)return;fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:a})}).then(function(r){if(r.ok)sessionStorage.setItem('wl-utm',sig);});}catch(e){}})();

/* Scroll reveal + size-chart link (Roy 10:07 redesign). IO only; reduced motion = no animation; no-JS = always visible. */
(function(){
  document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('[data-open-specs]');if(!a)return;var d=document.getElementById('wl-specs');if(d&&d.tagName==='DETAILS')d.open=true;});
  var els=document.querySelectorAll('[data-reveal]');
  if(!els.length||!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  document.documentElement.classList.add('wl-reveal-on');
  var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});},{rootMargin:'0px 0px -6% 0px',threshold:0.1});
  Array.prototype.forEach.call(els,function(el){
    var sibs=Array.prototype.filter.call(el.parentNode.children,function(c){return c.hasAttribute('data-reveal');});
    el.style.setProperty('--wl-d',Math.min(sibs.indexOf(el),5)*70+'ms');
    io.observe(el);
  });
})();
